import isChromatic from "chromatic/isChromatic";
import { useMemo } from "react";
export var useIsAnimationActive = function() {
    return useMemo(function() {
        return !isChromatic();
    }, []);
};

//# sourceMappingURL=useIsAnimationActive.js.map